import { render, staticRenderFns } from "./StudentQuizSubmissionViewer.vue?vue&type=template&id=193fec70&scoped=true&"
import script from "./StudentQuizSubmissionViewer.vue?vue&type=script&lang=js&"
export * from "./StudentQuizSubmissionViewer.vue?vue&type=script&lang=js&"
import style0 from "./StudentQuizSubmissionViewer.vue?vue&type=style&index=0&id=193fec70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193fec70",
  null
  
)

export default component.exports